<template>
  <div>
    <el-form
      label-width="100px"
      :model="form"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <select-input
            ref="textInput"
            :select-type-map="taskSearchTypeMap"
            :form="form"
            :default-search-type="searchType"
            @pressenter="handleSearch"
            input-class="text-input"
            select-class="type-select"
            class="select-input"
          ></select-input>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('cpTask.buyId')">
            <multiple-input
              v-model="form.buyIdList"
              :placeholder="$t('cpTask.buyIdPlaceholder')"
              formatter="number"
              clearable
            ></multiple-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('cpTask.contentType')">
            <el-select
              v-model="form.contentTypeList"
              clearable
              multiple
              :placeholder="$t('cpTask.contentTypePlaceholder')"
              @change="handleSearch"
            >
              <el-option
                v-for="(item, key) in contentTypeMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('cpTask.buyType')">
            <el-select
              v-model="form.buyTypeList"
              :placeholder="$t('cpTask.buyTypePlaceholder')"
              clearable
              multiple
              @change="handleSearch"
            >
              <el-option
                v-for="(item, key) in buyTypeMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('cpTask.reviewStatus')">
            <el-select
              v-model="form.cpCodeList"
              :placeholder="$t('cpTask.reviewStatusPlaceholder')"
              clearable
              multiple
              @change="handleSearch"
            >
              <el-option
                v-for="(item, key) in cpStatusMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('cpTask.status')">
            <el-select
              v-model="form.audioCodeList"
              :placeholder="$t('cpTask.statusPlaceholder')"
              clearable
              multiple
              @change="handleSearch"
            >
              <el-option
                v-for="(item, key) in trackStatusMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$t('cpTask.businessBroker')">
            <el-input
              :placeholder="$t('cpTask.businessBrokerPlaceholder')"
              v-model="form.businessBroker"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <div class="search-btn">
          <slot />
        </div>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import MultipleInput from '@/components/MultipleInput/index'
import SelectInput from '@/components/SelectInput/index'

import {
  taskSearchTypeMap,
  contentTypeMap,
  buyTypeMap,
  trackStatusMap,
  cpStatusMap,
} from '../const'

export default {
  name: 'CpTaskSearchForm',
  components: {
    MultipleInput,
    SelectInput
  },

  data() {
    return {
      taskSearchTypeMap,
      contentTypeMap,
      buyTypeMap,
      trackStatusMap,
      cpStatusMap,

      searchType: 'taskName__contains',
      form: {
        taskName__contains: '',
        idList: '',
        buyIdList: [],
        contentTypeList: [],
        buyTypeList: [],
        audioCodeList: [],
        cpCodeList: [],
        businessBroker: '',
      }
    }
  },

  computed: {
    formatForm() {
      const form = cloneDeep(this.form)

      // 处理任务ID
      form.idList = form.idList.split(',').filter(Boolean).map(Number)

      // 去除空数组
      Object.keys(form).forEach(key => {
        const value = form[key]
        if (Array.isArray(value) && value.length === 0) {
          form[key] = undefined
        }
      })
      return form
    }
  },

  created() {
    const id = this.$route.query.id || ''
    if (id) {
      this.searchType = 'idList'
      this.form.idList = String(id)
    }
  },

  methods: {
    handleSearch() {
      this.$emit('search')
    }
  },
}
</script>

<style lang="scss" scoped>
.search-btn {
  float: right;
  margin-right: 10px;
}

.input-with-select {
  width: 100px;
}

.el-form .el-form-item  {
  margin-bottom: 8px !important;
}

::v-deep {
  .type-select {
    width: 100px;
  }
  .text-input {
    flex: 1;
  }
}

</style>
